import { render, staticRenderFns } from "./empresasFormulario.vue?vue&type=template&id=22aa2a65&"
import script from "./empresasFormulario.vue?vue&type=script&lang=ts&"
export * from "./empresasFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports